import { render, staticRenderFns } from "./exporthk8.vue?vue&type=template&id=83bf4762"
import script from "./exporthk8.vue?vue&type=script&lang=js"
export * from "./exporthk8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports